/** Extract supervisor approval instance id from backend error messages. */
export function parseApprovalId(message: string): number | null {
  const match = message.match(/\(ID:\s*(\d+)\)/i);
  if (!match) return null;
  const id = Number(match[1]);
  return Number.isNaN(id) ? null : id;
}
